import {
  COMBINED_FILTERS_VIEW,
  FAVOURITES_VIEW,
  FIXTURES_VIEW,
  MARKETS_VIEW,
  ODDS_VIEW,
} from "../constants";
import { initialState } from "../state";

const filter = (state = initialState, action) => {
  switch (action.type) {
    case "SET_PP_CONFIG_DATA":
      return {
        ...state,
        ppConfig: action.payload,
      };
    case "SET_ACTIVE_FILTER_HEADER":
      return {
        ...state,
        activeView: action.payload,
      };
    case "TOGGLE_FILTER_SELECTION": {
      return {
        ...state,
        prefetchedFilters: {
          ...state.prefetchedFilters,
          [action.payload.filter]: action.payload.type,
        },
      };
    }
    case "ADD_TO_FILTER_SELECTIONS": {
      // type is an array of selections we want to spread into the existing array of selections for that filter
      if (Array.isArray(action.payload.type)) {
        return {
          ...state,
          prefetchedFilters: {
            ...state.prefetchedFilters,
            [action.payload.filter]: [...action.payload.type],
          },
        };
      }
      return {
        ...state,
        prefetchedFilters: {
          ...state.prefetchedFilters,
          [action.payload.filter]: [
            ...state.prefetchedFilters[action.payload.filter],
            action.payload.type,
          ],
        },
      };
    }

    case "REMOVE_FROM_FILTER_SELECTIONS": {
      if (Array.isArray(action.payload.type)) {
        const filteredArray = state.prefetchedFilters[
          action.payload.filter
        ].filter((item) => !action.payload.type.includes(item));
        return {
          ...state,
          prefetchedFilters: {
            ...state.prefetchedFilters,
            [action.payload.filter]: filteredArray,
          },
        };
      }
      return {
        ...state,
        prefetchedFilters: {
          ...state.prefetchedFilters,
          [action.payload.filter]: [
            ...state.prefetchedFilters[action.payload.filter].filter(
              (item) => item !== action.payload.type
            ),
          ],
        },
      };
    }

    case "ADD_FAVOURITES_FILTER_SELECTIONS": {
      const selectedFavourite = state.storedFavourites.find(
        (favourite) => favourite.id === action.payload.id
      );

      return {
        ...state,
        prefetchedFilters: {
          ...state.prefetchedFilters,
          [action.payload.type]: selectedFavourite[action.payload.type],
        },
      };
    }

    case "UPDATE_FILTER_FROM_FAVOURITE": {
      const { odds, markets } = action.payload;

      // only update the odds filters with the payload if they are not null
      const newOdds = odds.minOdds || odds.maxOdds ? odds : state.filters.odds;
      // only update the markets with those from the payload if they are not empty
      const newMarkets = markets.length > 0 ? markets : state.filters.markets;

      return {
        ...state,
        filters: {
          ...state.filters,
          odds: newOdds,
          markets: newMarkets,
        },
        prefetchedFilters: {
          ...state.prefetchedFilters,
          odds: newOdds,
          markets: newMarkets,
        },
      };
    }

    case "RESET_FILTER_FROM_FAVOURITE": {
      return {
        ...state,
        filters: {
          ...state.filters,
          odds: {
            minOdds: null,
            maxOdds: null,
          },
          markets: [],
        },
        prefetchedFilters: {
          ...state.prefetchedFilters,
          odds: {
            minOdds: null,
            maxOdds: null,
          },
          markets: [],
        },
      };
    }

    case "ADD_TO_FIXTURES_FILTER_SELECTIONS": {
      return {
        ...state,
        prefetchedFilters: {
          ...state.prefetchedFilters,
          [action.payload.filter]: {
            ...state.prefetchedFilters[action.payload.filter],
            [action.payload.date]: [
              ...state.prefetchedFilters[action.payload.filter][
                action.payload.date
              ],
              action.payload.fixture,
            ],
          },
        },
      };
    }
    case "REMOVE_FROM_FIXTURES_FILTER_SELECTIONS": {
      return {
        ...state,
        prefetchedFilters: {
          ...state.prefetchedFilters,
          [action.payload.filter]: {
            ...state.prefetchedFilters[action.payload.filter],
            [action.payload.date]: [
              ...state.prefetchedFilters[action.payload.filter][
                action.payload.date
              ].filter((item) => item !== action.payload.fixture),
            ],
          },
        },
      };
    }
    case "EMPTY_DATE_FIXTURES_FILTER_SELECTIONS": {
      return {
        ...state,
        prefetchedFilters: {
          ...state.prefetchedFilters,
          [action.payload.filter]: {
            ...state.prefetchedFilters[action.payload.filter],
            [action.payload.date]: [],
          },
        },
      };
    }
    case "ADD_TO_ODDS_SELECTIONS": {
      return {
        ...state,
        prefetchedFilters: {
          ...state.prefetchedFilters,
          [action.payload.filter]: {
            ...action.payload.odds,
          },
        },
      };
    }
    case "REMOVE_FROM_ODDS_SELECTIONS": {
      return {
        ...state,
        prefetchedFilters: {
          ...state.prefetchedFilters,
          [action.payload.filter]: {
            minOdds: null,
            maxOdds: null,
          },
        },
      };
    }
    case "FINALISE_FILTER_SELECTIONS": {
      const { favourites, ...rest } = state.prefetchedFilters;
      localStorage.setItem(
        "filters",
        JSON.stringify({
          ...rest,
        })
      );
      return {
        ...state,
        filters: {
          ...state.prefetchedFilters,
        },
      };
    }
    case "SET_NUMBER_OF_MARKET_SELECTIONS": {
      return {
        ...state,
        numberOfMarketSelections: action.payload,
      };
    }

    case "SavedFavourites": {
      return {
        ...state,
        storedFavourites: action.payload.favourites,
      };
    }

    case "ADD_FAVOURITE_SELECTIONS": {
      const selectedFavourite = state.storedFavourites.find(
        (favourite) => favourite.id === action.payload.id
      );

      // if selectedFavourite.type is markets we want to add the markets to the prefetchedFilters
      if (selectedFavourite.type === MARKETS_VIEW) {
        return {
          ...state,
          prefetchedFilters: {
            ...state.prefetchedFilters,
            markets: selectedFavourite.markets,
            favourites: {
              ...state.prefetchedFilters.favourites,
              markets: action.payload.id,
            },
          },
        };
      }

      // if selectedFavourite.type is odds we want to add the odds to the prefetchedFilters
      if (selectedFavourite.type === ODDS_VIEW) {
        return {
          ...state,
          prefetchedFilters: {
            ...state.prefetchedFilters,
            odds: selectedFavourite.odds,
            favourites: {
              ...state.prefetchedFilters.favourites,
              odds: action.payload.id,
            },
          },
        };
      }
    }

    case "REMOVE_FAVOURITE_SELECTIONS": {
      const selectedFavourite = state.storedFavourites.find(
        (favourite) => favourite.id === action.payload.id
      );

      if (selectedFavourite.type === MARKETS_VIEW) {
        return {
          ...state,
          prefetchedFilters: {
            ...state.prefetchedFilters,
            markets: state.prefetchedFilters.markets.filter(
              (market) => !selectedFavourite.markets.includes(market)
            ),
            favourites: {
              ...state.prefetchedFilters.favourites,
              markets: null,
            },
          },
        };
      }
      if (selectedFavourite.type === ODDS_VIEW) {
        return {
          ...state,
          prefetchedFilters: {
            ...state.prefetchedFilters,
            odds: {
              minOdds: null,
              maxOdds: null,
            },
            favourites: {
              ...state.prefetchedFilters.favourites,
              odds: null,
            },
          },
        };
      }
    }

    case "REMOVE_FAVOURITE_FROM_FILTER": {
      if (action.payload.type === MARKETS_VIEW) {
        return {
          ...state,
          prefetchedFilters: {
            ...state.prefetchedFilters,
            markets: state.prefetchedFilters.markets.filter(
              (market) => !action.payload.markets.includes(market)
            ),
            favourites: {
              ...state.prefetchedFilters.favourites,
              markets: null,
            },
          },
        };
      }
      if (action.payload.type === ODDS_VIEW) {
        return {
          ...state,
          prefetchedFilters: {
            ...state.prefetchedFilters,
            odds: {
              minOdds: null,
              maxOdds: null,
            },
            favourites: {
              ...state.prefetchedFilters.favourites,
              odds: null,
            },
          },
        };
      }
    }

    case "RESET_FAVOURITE_SELECTIONS": {
      return {
        ...state,
        prefetchedFilters: {
          ...state.prefetchedFilters,
          favourites: {
            markets: null,
            odds: null,
          },
          odds: {
            minOdds: null,
            maxOdds: null,
          },
          markets: [],
        },
      };
    }
    case "RESET_FILTER_SELECTIONS": {
      localStorage.setItem("filters", JSON.stringify({}));

      if (action.payload.type === COMBINED_FILTERS_VIEW) {
        return {
          ...state,
          prefetchedFilters: {
            ...state.prefetchedFilters,
            odds: {
              minOdds: null,
              maxOdds: null,
            },
            markets: [],
            date: [],
            fixtures: { today: [], tomorrow: [] },
          },
        };
      }

      function defaultState(type) {
        if (type === FIXTURES_VIEW) {
          return { today: [], tomorrow: [] };
        }
        if (type === ODDS_VIEW) {
          return { minOdds: null, maxOdds: null };
        }
        if (type === FAVOURITES_VIEW) {
          return { markets: null, odds: null };
        }
        return [];
      }
      return {
        ...state,
        prefetchedFilters: {
          ...state.filters,
          [action.payload.type]: defaultState(action.payload.type),
        },
        numberOfMarketSelections: 0,
      };
    }
    case "RESET_PREFETCHED_FILTERS": {
      return {
        ...state,
        prefetchedFilters: {
          ...state.filters,
        },
      };
    }
    case "RESET_FILTERS": {
      return {
        ...state,
        filters: {
          ...state.prefetchedFilters,
        },
      };
    }

    case "SET_ONBOARDING_STEP": {
      return {
        ...state,
        onboardingStep: action.payload,
        prevOnboardingStep: state.onboardingStep,
      };
    }

    case "EDIT_FAVOURITE": {
      return {
        ...state,
        selectedFavourite: action.payload,
      };
    }

    case "UPDATE_STORED_FAVOURITE_NAME": {
      return {
        ...state,
        storedFavourites: state.storedFavourites.map((favourite) =>
          favourite.id === action.payload.id
            ? { ...favourite, name: action.payload.newName }
            : favourite
        ),
        selectedFavourite: "",
      };
    }

    case "UPDATE_STORED_FAVOURITE": {
      return {
        ...state,
        storedFavourites: state.storedFavourites.map((favourite) =>
          favourite.id === action.payload.id
            ? {
                ...favourite,
                markets: [
                  ...new Set([
                    ...(favourite.markets ?? []),
                    ...action.payload.markets,
                  ]),
                ],
              }
            : favourite
        ),
      };
    }

    case "UpdateFavouritesResponse": {
      return {
        ...state,
        responseMessage: action.payload,
      };
    }

    default:
      return state;
  }
};

export default filter;
